export default __webpack_public_path__ + "static/media/DFAxCMU.44c45579.png";